import { useContext } from 'react';

import { driverOptionsContext } from './driverOptionsContext';

export const useDriverOptions = () => {
  const driverOptions = useContext(driverOptionsContext);

  if (driverOptions === undefined) {
    throw new Error('useDriverOptions must be called inside a DriverOptionsProvider and with a value');
  }

  return driverOptions;
};
